var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "../api-client";
import { UNILITIES_ENDPOINTS } from "./endpoints";
// In-memory cache for signed URLs
const signedUrlCache = {};
/**
 * Get a signed S3 URL for secure access, with caching and expiration handling.
 * @param {string} url - The original S3 URL to sign.
 * @returns {Promise<string>} - The signed URL.
 */
export function signS3Url(url) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        const cached = signedUrlCache[url];
        const now = new Date();
        if (cached && new Date(cached.expiresAt) > now) {
            return cached.signedUrl;
        }
        try {
            const encodedUrl = encodeURIComponent(url);
            const response = yield apiClientServices.get(UNILITIES_ENDPOINTS.SIGN_URL, {
                params: { url: encodedUrl },
            });
            if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.status) === 200 &&
                ((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.signedUrl) &&
                ((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.expiresAt)) {
                signedUrlCache[url] = {
                    signedUrl: response.data.result.signedUrl,
                    expiresAt: response.data.result.expiresAt,
                };
                return response.data.result.signedUrl;
            }
            else {
                throw new Error("Failed to sign S3 URL");
            }
        }
        catch (err) {
            throw err;
        }
    });
}
